import React from 'react';
import { FaPoll, FaImages, FaStream, FaMicrophone, FaLink, FaFileAlt } from 'react-icons/fa';

const postTypes = [
  { id: 'post', name: 'Point', Icon: FaFileAlt, description: 'Regular point' },
  { id: 'poll', name: 'Poll', Icon: FaPoll, description: 'Create a poll' },
  { id: 'carousel', name: 'Carousel', Icon: FaImages, description: 'Multiple images' },
  { id: 'thread', name: 'Talk', Icon: FaStream, description: 'Connected points' },
  { id: 'audio', name: 'Audio', Icon: FaMicrophone, description: 'Voice or audio' },
  { id: 'link', name: 'Link', Icon: FaLink, description: 'Share a link' },
];

const PostTypeSelector = ({ postType, setPostType }) => (
  <div className="mb-6">
    <label className="text-sm text-gray-600 mb-2 block">Post Type</label>
    <div className="flex flex-wrap gap-2">
      {postTypes.map(({ id, name, Icon }) => (
        <button
          key={id}
          type="button"
          onClick={() => setPostType(id)}
          className={`flex items-center space-x-2 px-4 py-2 rounded-full text-sm font-medium transition-all ${
            postType === id
              ? 'bg-gradient-to-r from-[#4A90E2] to-[#A855F7] text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
          data-testid={`post-type-${id}`}
        >
          <Icon className="text-sm" />
          <span className={name === 'Point' ? 'font-arthaus' : ''}>{name}</span>
        </button>
      ))}
    </div>
  </div>
);

export default PostTypeSelector;
